import { assumeArrayOfObject, assumeObject } from '../type-guards/assumeType';
import type { FolderDto } from '../dto/folderModels';
import { FolderTypeName } from '../dto/folderModels';
import type { ApiCommand, ApiRequest } from './apiCommand';

export class GetFolderCommand implements ApiCommand<FolderDto> {
  constructor(private input: { folderId: string }) {
  }
  request(): ApiRequest {
    return {
      linkName: 'folder',
      pathParams: {
        folderId: this.input.folderId
      },
      queryParams: {},
      method: 'GET',
      body: null
    };
  }
  asOutput(body: unknown): FolderDto {
    return assumeObject<FolderDto>(body, 'hasSubfolder');
  }
}

export class GetFirstChildFoldersBatchCommand implements ApiCommand<FolderDto[]> {
  constructor(private input: { folderId: string }) {
  }
  request(): ApiRequest {
    return {
      linkName: 'folderContent',
      pathParams: {
        folderId: this.input.folderId
      },
      queryParams: {
        type: FolderTypeName,
      },
      method: 'GET',
      body: null
    };
  }
  asOutput(body: unknown): FolderDto[] {
    return assumeArrayOfObject<FolderDto>(body, 'hasSubfolder');
  }
}
